import {

  GET_SALESPERSON_HIERARCHY_REQUEST, GET_SALESPERSON_HIERARCHY_SUCCESS, GET_SALESPERSON_HIERARCHY_ERROR, GET_ALL_SALEPERSON_HIERARCHY_ERROR, GET_ALL_SALEPERSON_HIERARCHY_REQUEST, GET_ALL_SALEPERSON_HIERARCHY_SUCCESS,
CREATE_SALESPERSON_HIERARCHY_REQUEST,
CREATE_SALESPERSON_HIERARCHY_SUCCESS,
CREATE_SALESPERSON_HIERARCHY_ERROR,
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_SALESPERSON_HIERARCHY_REQUEST:
      return {
        loading: true,
      };
    case GET_SALESPERSON_HIERARCHY_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_SALESPERSON_HIERARCHY_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_ALL_SALEPERSON_HIERARCHY_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_SALEPERSON_HIERARCHY_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_ALL_SALEPERSON_HIERARCHY_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };


    default:
      return state;
  }
}
